import Header from '@/components/component/Header/Header.vue'
import MainNavigationMenu from '@/components/component/MainNavigationMenu/MainNavigationMenu.vue'
import {cloneDeep, isEmpty, uniq} from 'lodash'
import SearchOnTop from '@/components/component/Reuse/SearchOnTop/SearchOnTop.vue'
import settings from '@/libs/constant/settings'
import {getContentList, getUserProfile, getSubscriptions, logoutCall, organisationWithoutCollab} from '@/libs/api/api'
import {getAticleColumns, getTableOptions, getArticleTableSettingsOptions} from './getArticleData'
import {getUserTableSettingsOptions, getUserColumns, getUserTableOptions} from './getUserData'
import {getAuthorColumns, getAuthorTableOptions, getAuthorTableSettingsOptions} from './getAuthorData'
import {getPublisherColumns, getPublisherTableOptions, getPublisherTableSettingsOptions} from './getPublisherData'
import {getPublicationColumns, getPublicationTableOptions, getPublicationTableSettingsOptions} from './getPublicationData'
import { loader, checkIfAdmin, message, getAppliedFilters, errorHandler, logout} from '../../../libs/helper'
import constants from '../../../libs/constant/constants'
import pageRoutes from '@/libs/constant/pageRoutes'
import { mapGetters } from 'vuex'

export default {
    name: 'AdminHome',
    data() {
        return {
            clickedOn: '',
            menuItem: {},
            columns: [],
            displayList: [],
            tableOptions: {},
            tableData: [],
            tableSettingOptions: [],
            category: '',
            limit: 25,
            currentPage: 1,
            skip: 0,
            selectedValue: 10,
            totalTableData: 0,
            previousPage : 1,
            sort: 'name',
            order: 'asc',
            showTableSettings: false,
            className: '',
            selectedTableFilters: {},
            updateCount: {isUpdate: false}
        }
    },
    created() {
        // api call to get the profile
        organisationWithoutCollab()
        .then(response => {
            this.$store.dispatch('setOrganisationsWithoutCollaborator', response)
            if (response.length > 0) {
                // main account info of user
                let mainAccountInfo = response[0]
                // set user info in store
                this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, mainAccountInfo);
                // check if the current account is admin account
                if(mainAccountInfo.is_admin) localStorage.setItem('accura_ad', constants.ROLE.ADMIN)
                // set language in locale
                this.$i18n.locale = mainAccountInfo.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB;
                // persist language in local storage
                localStorage.setItem('lang', mainAccountInfo.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
            }
        }).catch(error => {
            message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
        })
    },

    beforeCreate(){
        loader(this,true)
        getUserProfile({})
            .then(response => {
                if (response && response.id) {
                    loader(this,false)
                    this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                    this.$i18n.locale = response.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB;
                    localStorage.setItem('lang', response.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
                }

                if (response && (response.id || response._id)) {
                    localStorage.setItem('activeProfile', response.id || response._id)
                    this.$store.dispatch('setSelectedAccount', response || {})
                }

                loader(this,false)
            })
            .catch((error)=> {
                loader(this,false)
                return error
                ///message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
    },
    
    beforeMount() {
        if(this.$route.name === pageRoutes.infoArticles) {
            this.category = constants.ADMIN.Articles.value_without_s
        } else if (this.$route.name === pageRoutes.infoPublishers) {
            this.category = constants.ADMIN.Publishers.value_without_s
        } else if (this.$route.name === pageRoutes.infoPublications) {
            this.category = constants.ADMIN.Publications.value_without_s
        } else if (this.$route.name === pageRoutes.infoAuthors) {
            this.category = constants.ADMIN.Authors.value_without_s
        } else if (this.$route.name === pageRoutes.userSubscription) {
            this.category = constants.ADMIN.Users.value_without_s
        } else {
            this.category = ''
        }
        this.$store.dispatch('setType', this.category)
    },
    mounted() {
        this.fetchMenuFor(this.category)
    },
    computed: {
        ...mapGetters({
            userInformation: constants.getters.GET_USER_INFORMATION,
            organisationWithoutCollaborator: constants.getters.GET_ORGANSIATION_WITHOUT_COLLABORATOR,
            selectedAccount: constants.getters.GET_SELECTED_ACCOUNT,
            container: 'getContainer',
            hideSearchOnTop: 'getHideSearchOnTop',
            callPublishers: 'getCallPublishers'
        })
    },
    watch: {
        callPublishers (value) {
            if (!isEmpty(value)) {
                this.fetchMenuItem(value)
            }
        }
    },
    components:{
        Header, MainNavigationMenu, SearchOnTop
    },
    beforeRouteEnter(to, from, next) {
        if (!checkIfAdmin()) {
            logoutCall({}).then(response => {
                message(this, constants.messageType.SUCCESS, response.message)
            }).catch(error => error)
            let lang = localStorage.getItem('lang')
            localStorage.clear();
            localStorage.setItem('lang', lang || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
            next({
                name: 'signin-page'
            })
        }
        next()
    },
    methods:{
        /**
         * To fetch the list of data corresponding to menu item selected
         * @param {*} item -> menuItem selected
         */
        getList: async function (item) {
            this.selectedTableFilters = {}
            this.$store.dispatch('setTableFilters', {})
            this.$store.dispatch('setClearFilters', true)
            switch(item.label) {        
                case 'Articles': 
                try {
                    this.sort = 'title'
                     this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                     this.columns = getAticleColumns()
                     this.tableOptions = getTableOptions()
                     this.tableSettingOptions = getArticleTableSettingsOptions()
                }
                 catch(error) {
                    this.displayList= {}
                    return error
                 }
                break
                case 'Authors':
                        try {
                            this.sort='first_name'
                            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                             this.columns = getAuthorColumns()
                             this.tableOptions = getAuthorTableOptions()
                             this.tableSettingOptions = getAuthorTableSettingsOptions()
                        }
                         catch(error) {
                            this.displayList= {}
                            return error
                         }
                break
                case 'Publications':
                        try {                           
                            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                            this.columns = getPublicationColumns()
                            this.tableOptions = getPublicationTableOptions()
                            this.tableSettingOptions = getPublicationTableSettingsOptions()
                        }
                         catch(error) {
                            this.displayList= {}
                            return error
                         }
                 break
                 case 'Publishers':
                        try {
                            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                            this.columns = getPublisherColumns()
                            this.tableOptions = getPublisherTableOptions()
                            this.tableSettingOptions = getPublisherTableSettingsOptions()
                        }
                         catch(error) {
                            this.displayList= {}
                            return error
                         }
                 break    
                 case 'Users': 
                         
                         try {
                            this.sort='first_name'
                            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                             this.columns = getUserColumns()
                             this.tableOptions = getUserTableOptions()
                             this.tableSettingOptions = getUserTableSettingsOptions()
                         } catch (error) {
                             console.warn(error)
                         }
                 break            
            }
        },
        fetchMenuFor (type) {
            if (type === '') {
                // this.$router.push({name: 'user-overview'})
            } else {
                this.selectedTableFilters= {}
                this.$store.dispatch('setTableFilters', {})
                this.$store.dispatch('setClearFilters', true)
                this.getTableDataList(type)
            }
        },
        fetchMenuItem (item) {
            localStorage.setItem('selectedMenuItem', JSON.stringify(item))
            this.$store.dispatch('setClearFilters', true)
            this.clearData()
            this.clickedOn = item.label
            this.className = item.className
            this.menuItem = item
            if (item.label === 'Overview') {
                this.category = ''
                this.$router.push({name: pageRoutes.infoOverview}).catch(() => {})
            } else {
                this.changeRecord(10)
                this.category = constants.ADMIN[item.label].value_without_s
                let route = constants.GET_DATA[this.category].routeName
                this.$store.dispatch('setType', this.clickedOn.slice(0, this.clickedOn.length-1).toUpperCase())
                this.getList(this.menuItem)
                this.$router.push({name: route}).catch(() => {})
                this.$store.dispatch('setCallPublishers', {})
            }
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            this.skip = (currentPage - 1) * this.selectedValue
            
            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
        },
        changeRecord (record) {
            this.selectedValue = record
        },
        fetchNewRecord: async function (skip, limit, sort, order) {
            try{
                loader(this,true)
                let body = getAppliedFilters(cloneDeep(this.selectedTableFilters))
                let params= `?skip=${skip}&limit=${limit}&sort=${sort}&order=${order}`
                if (this.category === constants.ADMIN.Users.value_without_s) {
                    let users = await getSubscriptions(params, body) 
                    this.displayList = users.items || []
                    this.totalTableData = users.total_count
                    if (isEmpty(body)) this.changeUpdateCount({isUpdate: true, count: users.total_count, category: this.category})
                } else {
                    
                    let response = await getContentList(constants.GET_DATA[this.category].value, params, body)
                    if (isEmpty(body)) {
                        this.changeUpdateCount({isUpdate: true, count: response.total_count, category: this.category})
                    }
                    this.displayList = cloneDeep(response.items)
                    this.totalTableData = response.total_count
                }
                
                this.tableData = this.displayList
                this.$store.dispatch('setTableData', this.tableData)
                
                loader(this, false)
            }
            catch(error){
                loader(this, false)
                console.warn(error)
            }
        },
        clearData() {
            this.displayList = []
            this.skip = 0
            this.sort = 'name'
            this.order = 'asc'
            this.tableData = []
        },
        sorting (type, order, sort) {
            this.skip = 0
            this.order= order
            this.currentPage = 1
            this.sort = sort
            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
        },
        /*
     * updateColumnsInTable() called when user clicks update button
     * table setting menu options and add/remove the columns in the table
     * */
    updateColumnsInTable (columnsToAdd, list, type) {
        this.columns = uniq(columnsToAdd)
        this.tableSettingOptions = list

        switch (type) {
            case constants.ADMIN.Publishers.value_without_s:
                localStorage.setItem('publisherColumns', JSON.stringify(this.columns))
                break
            case constants.ADMIN.Publications.value_without_s:
                localStorage.setItem('publicationColumns', JSON.stringify(this.columns))
                break
            case constants.ADMIN.Authors.value_without_s:
                localStorage.setItem('authorColumns', JSON.stringify(this.columns))
                break
            case constants.ADMIN.Articles.value_without_s:
                localStorage.setItem('articleColumns', JSON.stringify(this.columns))
                break
            case constants.ADMIN.Users.value_without_s:
                localStorage.setItem('userColumns', JSON.stringify(this.columns))
                break
        }
      },
       /*
      * returns the file name according to env
      * to save table columns setting.
      * */
    tableFileName (env) {
        switch (env) {
          case constants.ENV.PRODUCTION:
            return '/adminTableColumnProd'
          case constants.ENV.STAGING:
            return '/adminTableColumnStaging'
          case constants.ENV.DEVELOPMENT:
            return '/adminTableColumnDev'
        }
      },
      refreshPage(){
          this.changePage(this.currentPage)
      },
      getTableDataList: async function (item) {
        this.clearData()
        switch(item) {        
            case constants.ADMIN.Articles.value_without_s: 
                try {
                    this.sort = 'title'
                    this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                    this.columns = getAticleColumns()
                    this.tableOptions = getTableOptions()
                    this.tableSettingOptions = getArticleTableSettingsOptions()
                }
                catch(error) {
                    this.displayList= {}
                    return error
                }
            break
            case constants.ADMIN.Authors.value_without_s:
                try {
                    this.sort='first_name'
                    this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                        this.columns = getAuthorColumns()
                        this.tableOptions = getAuthorTableOptions()
                        this.tableSettingOptions = getAuthorTableSettingsOptions()
                    }
                    catch(error) {
                    this.displayList= {}
                    return error
                    }
            break
            case constants.ADMIN.Publications.value_without_s:
                    try {                           
                        this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                        this.columns = getPublicationColumns()
                        this.tableOptions = getPublicationTableOptions()
                        this.tableSettingOptions = getPublicationTableSettingsOptions()
                    }
                     catch(error) {
                        this.displayList= {}
                        return error
                     }
             break
             case constants.ADMIN.Publishers.value_without_s:
                    try {
                        this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                        this.columns = getPublisherColumns()
                        this.tableOptions = getPublisherTableOptions()
                        this.tableSettingOptions = getPublisherTableSettingsOptions()
                    }
                     catch(error) {
                        this.displayList= {}
                        return error
                     }
                break
                case constants.ADMIN.Users.value_without_s:
                        try {
                            this.sort='first_name'
                            this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
                            this.columns = getUserColumns()
                            this.tableOptions = getUserTableOptions()
                            this.tableSettingOptions = getUserTableSettingsOptions()
                        } catch (error) {
                            console.warn(error)
                        }
                    break
                default:
                    // this.$router.push({name: 'user-overview'})
                    this.category = ''             
            }
            
        },
        setTableFilters (filters) {
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        },
        applyFilters () {
            let filtersToApply = {}
            if (!isEmpty(this.selectedTableFilters)) {
                if (this.selectedTableFilters.city && this.selectedTableFilters.city.length > 0) {
                    filtersToApply.city = this.selectedTableFilters.city
                }
                if (this.selectedTableFilters.name && this.selectedTableFilters.name.length > 0) {
                    filtersToApply.name = this.selectedTableFilters.name
                }
            } 
            this.selectedTableFilters = filtersToApply
            return this.selectedTableFilters
        },
        filterCall() {
            this.changePage(1)
        },
        changeUpdateCount (updateData) {
            this.updateCount = updateData
        }
    }
}